 import {updateFlowStatus} from '@/api/page.js'
 import {updateRecheckInfoStatus} from '@/api/Reinspection/index.js'
 
 
 // 草稿
export function updateInfoStatus(jyjcInfoId,status,processInstanceID,projectAddress,flowCreateTime){
    return new Promise((resolve) => {
        updateFlowStatus({
            flowStatus:status,   //  0是草稿状态  1 是一级审核 2是二级审核 3是三级审核 -1是以及驳回 -2 是耳机驳回 -3是三级驳回
            // flowId:processInstanceID,
            id:jyjcInfoId,    //相关检验检测ID
            projectAddress:projectAddress,
            flowCreateTime:flowCreateTime
          }).then((res)=>{
              console.log('草稿',res)
              resolve(true)
          })
    }) 
}

export function UpdateRecheckInfoStatus(recheckId,status,projectAddress,flowCreateTime){
    return new Promise((resolve) => {
        updateRecheckInfoStatus({
            id:recheckId,    //相关检验检测ID
            flowStatus:status,   //  0是草稿状态  1 是一级审核 2是二级审核 3是三级审核 -1是以及驳回 -2 是耳机驳回 -3是三级驳回
            projectAddress:projectAddress,
            flowCreateTime:flowCreateTime
          }).then((res)=>{
              console.log('草稿',res)
              resolve(true)
          })
    }) 
}

